import React from 'react';
import { TransitionWrapper } from '../../Helpers/transitionWrapper';
import { getLabel } from '../../Language/labels';
import { setCompetitionTab } from '../../Navigation/currentTab';
import { TAB_CATEGORIES } from '../../enums';

export const EntryStatus = ({ dispatch }) => {
  return (
    <TransitionWrapper>
      <h1 className='screen-title'>{getLabel('entrySubmitTitle')}</h1>
      <div className='entry-status'>
        <div>
          <h1>{getLabel('entrySubmitted')}</h1>
          <div className='entry-status-back'>
            <button type='button' onClick={() => dispatch(setCompetitionTab(TAB_CATEGORIES))} className='form-submit'>{getLabel('backToCompetition')}</button>
          </div>
        </div>
      </div>
    </TransitionWrapper>
  )
}